import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
          username: window.localStorage.getItem('username'),
          power: window.localStorage.getItem('power'),
          identity: window.localStorage.getItem('identity'),
          expirationTime: window.localStorage.getItem('expirationTime')
        }
    },
    mutations: {},
    actions: {},
    modules: {}
})

Storage.prototype.setExpire = (key, value, expire) => {
  let obj = {
    data: value,
    expire: expire
  };
  //localStorage 设置的值不能为对象,转为json字符串
  localStorage.setItem(key, JSON.stringify(obj));
}

Storage.prototype.getExpire = key => {
  let val = localStorage.getItem(key);
  if (!val) {
    return val;
  }
  val = JSON.parse(val);
  if (Date.now() > val.expire) {
    localStorage.removeItem(key);
    return null;
  }
  return val.data;
}

/*
export const setScoreItem =  => {

};*/



// WEBPACK FOOTER //
// ./src/assets/js/store.js